import { Field, TagInput } from "@/shared/foundation/primitives";

interface TagsAutocompleteProps {
  value: string[];
  onChange: (next: string[]) => void;
  options: string[];
  label?: string;
  placeholder?: string;
  helperText?: string;
  disabled?: boolean;
}

/**
 * The skill dialogs' tag field: the foundation TagInput under a label, with
 * the org's skill tags as suggestions. **Blur commits pending text**: if the
 * user types a value and clicks Save (or Tabs out) without pressing Enter,
 * the typed text is added as a tag before the click handler reads `value`.
 * Browser event ordering (blur fires before click on the Save button) makes
 * this a single source of truth — consumers can read `value` after Save
 * fires and trust that the typed-but-not-Enter'd tag is already in it.
 */
export function TagsAutocomplete({
  value,
  onChange,
  options,
  label = "Tags",
  placeholder = "Add a tag",
  helperText,
  disabled = false,
}: TagsAutocompleteProps) {
  return (
    <Field.Root disabled={disabled}>
      <Field.Label>{label}</Field.Label>
      <TagInput
        tags={value}
        onChange={onChange}
        suggestions={options}
        placeholder={placeholder}
        disabled={disabled}
        aria-label={label}
      />
      {helperText && <Field.Description>{helperText}</Field.Description>}
    </Field.Root>
  );
}
